<div [ngClass]="containerClass" class="layout-wrapper flex flex-col min-h-screen">

	<p-toast position="top-center" key="tc" preventOpenDuplicates="true" />
	<p-confirmdialog #cd />
	<app-global-top-banner></app-global-top-banner>
	<app-header></app-header>
	<app-bottom-nav></app-bottom-nav>
	@if (hydration.hydrated() && keycloakService.authenticated && !layoutService.showLanding()) {
		<div [class.layout-side-bar-left]="langService.currentLanguage() === 'en'" class="layout-sidebar shadow-lg">
			<app-sidebar />
		</div>
	}

	<div class="flex-1 flex flex-col pb-16 lg:pb-0">
	@if (!hydration.hydrated() || !keycloakService.authenticated || layoutService.showLanding()) {
<!--		<app-landing-page/>-->
		<router-outlet
			[style.padding-top]="isLandingPage() ? 'calc(var(--banner-h, 0px))' : 'calc(var(--banner-h, 0px) + 5rem)'"
			></router-outlet>
	} @else {
		<!-- بخش اصلی -->
		<div [style.padding-inline]="paddingInline" class="layout-main-container flex-1 flex flex-col">
			<div class="layout-main flex-1">
				<router-outlet></router-outlet>
			</div>
		</div>
	}
	@if (!hydration.hydrated() || !keycloakService.authenticated || isLandingPage()) {
		<!-- ✅ فوتر که پایین می‌چسبد -->
		<div class="mt-auto">
			<app-footer class="w-full"></app-footer>
		</div>
	}
	</div>
	<div class="layout-mask animate-fadein"></div>
</div>

<app-accept-agreement-modal
	[visible]="isUnassignedAgreementModalVisible()"
	[unsignedAgreementId]="firstUnsignedAgreementId()" />

<div
	[ngClass]="{
		'right-6 flex-row': langService.dir() === 'ltr',
		'left-6 flex-row-reverse': langService.dir() === 'rtl',
	}"
	class="fixed bottom-6 z-50 flex gap-3">
	<!--	<p-button-->
	<!--		[pTooltip]="'footer.backToTop' | translate"-->
	<!--		(click)="scrollToTop()"-->
	<!--		class="shadow-lg transition duration-300">-->
	<!--		<i class="pi pi-arrow-up py-2" style="font-size: 1rem"></i>-->
	<!--	</p-button>-->

	@if (showInstallButton()) {
		<p-button (click)="addToHomeScreen()" class="shadow-lg">
			<i class="pi pi-home py-2" style="font-size: 1rem"></i>
		</p-button>
	}

	@if (hydration.hydrated() && shouldShowIosGuide()) {
		<div class="bg-white p-3 rounded shadow-lg text-sm">
			📲 To install Bazargah, tap <b>Share</b> → <b>Add to Home Screen</b>
			<i (click)="shouldShowIosGuide.set(false)" class="pi pi-times"></i>
		</div>
	}
</div>

<p-dialog
	[visible]="dialogVisible()"
	[modal]="true"
	[closable]="true"
	[showHeader]="false"
	(visibleChange)="dialogVisible.set($event)"
	styleClass="w-[900px] max-w-[95vw] rounded-2xl overflow-hidden"
	contentStyleClass="p-0">
	<div class="min-h-[600px] p-8 text-white">
		<!-- Header -->
		<div class="text-center mb-10">
			<h2 class="text-4xl font-bold mb-3"> نقش خود را انتخاب کنید </h2>

			<p class="text-gray-500 text-lg"> شما می‌توانید بعدا بین نقش‌ها جابجا شوید. </p>
		</div>

		<!-- Cards -->
		<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
			@for (role of roles(); track role.key) {
				<div
					(click)="selectRole(role)"
					class="bg-gray-100 rounded-2xl p-6 min-h-[220px] flex flex-col justify-between cursor-pointer hover:scale-[1.02] transition border border-gray-100">
					<div class="flex justify-end">
						<div [class]="role.bg" class="w-16 h-16 rounded-xl flex items-center justify-center">
							<i [class]="role.icon" class="pi text-white text-2xl"></i>
						</div>
					</div>

					<div class="text-right text-black">
						<h3 class="text-2xl font-bold mb-2">
							{{ role.title }}
						</h3>

						<p class="text-gray-600">
							{{ role.desc }}
						</p>
					</div>
				</div>
			}
		</div>
	</div>
	<ng-template pTemplate="footer">
		<button (click)="dialogVisible.set(false)" pButton>
			{{ 'actions.later' | translate }}
		</button>
	</ng-template>
</p-dialog>
